// Imports
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
// UI Imports
import Typography from "@material-ui/core/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import BusinessCenter from '@mui/icons-material/BusinessCenter';

import { messageShow } from "../../common/api/actions";
import { detail } from "../../setting/api/actions/query";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  Menu as MenuIcon,
  ArrowBack as ArrowBackIcon,
  SpaceDashboard as IconDashboardOutlined,
  LocalMall as IconShoppingCartOutlined,
  Collections as IconPhotoLibraryOutlined,
  Widgets as IconCategoryOutlined,
  ViewModule as IconFilterNoneOutlined,
  AccountCircle as AccountCircleIcon,
  Diversity3 as IconPeopleOutline,
  LocationOn as IconLocationCityOutlined,
  Chat as IconForumOutlined,
  Analytics as IconBarChart,
  Telegram as SendIcon,
  ShowChart as TrendingUpRoundedIcon,
  QuestionAnswer as QuizIcon,
  Redeem as GiftIcon,
  CoPresent as CoPresentIcon,
  QrCode2 as QrCode,
  BusinessCenter as Marketing,
  Timeline as Analytics,
  Share as Engagement,
  Build as Utilities,
  Security as SecurityIcon,
  Psychology as PsychologyIcon,
  BookOnlineOutlined as BookOnlineOutlinedIcon,
  Event as EventIcon,
  TableRestaurant as TableRestaurantIcon,
  Store as StoreIcon,
  Description as DescriptionIcon,
  Settings as SettingsIcon,
  Email as EmailIcon,
  People as PeopleIcon
} from "@mui/icons-material";
// App Imports
import params from "../../../setup/config/params";
import routes from "../../../setup/routes";
import styles from "./styles";
import Tooltip from "@mui/material/Tooltip";
import { PermMedia as IconMediaGallery } from "@mui/icons-material";

let defaultImage = ""
let logo =""
// Component
class Sidebar extends PureComponent {
  constructor(props) {
    super(props);
    this.settings = {
      isRewardsSubscribed: false,
      isMessagingSubscribed:false,
      isAnalyticsSubscribed:false,
      showGrowthMenu:false,
      isStoreSubscribed: false,
      isDocumentManagerEnabled: false,
      isResourceEnabled: false
    };

    this.state = {
      settings: this.settings,
      isHovered: false,  
      isSidebarOpen: true,    
      isAExpanded: false,
      roles: [],
      permissions: {},
      roleName:""
    };
  }

  loadRoles = async () => {
      try {
          const userRole = localStorage.getItem("user");
          this.setState({
            roles: JSON.parse(userRole).roleDetails || [],
            permissions: JSON.parse(userRole).roleDetails.permissions || {},
            roleName : JSON.parse(userRole).roleDetails.name || ""
          });
      } catch (error) {
          this.setState({ 
              roles: [],
              permissions: {},
              roleName:""
          });
          console.error("Error loading role:", error);
      }
  };

  isActiveRoute = (...routePaths) => {
    const { location } = this.props;

    return routePaths.some(path => location.pathname.indexOf(path) !== -1) ? "warning" : "inherit";
  };

  componentDidMount() {
    this.refresh();
    setTimeout(() => {
      this.loadRoles();
    }, 1000); 
    window.addEventListener('resize', this.handleResize);

  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }


  refresh = async () => {
    const { detail, messageShow } = this.props;
    try {
      const {
        match: {
          params: { vendorId },
        },
      } = this.props;
      this.setState({
        settings: { vendorId },
      });
      const { data } = await detail({ vendorId });
      if (data.success && data.data) {
        const { isRewardsSubscribed, isMessagingSubscribed, isAnalyticsSubscribed, showGrowthMenu, isTableReservationEnabled, ischatBotEnabled, isMediaGalleryEnabled, isDocumentManagerEnabled, campaignUrl, invoicesUrl, isQrDiningEnabled, isCampaignSubscribed, isInvoiceSubscribed, isStoreSubscribed, seoUrl, isSeoOptimizationEnabled } = data.data;
        this.setState({
          settings: {
            ...this.state.settings,
            isRewardsSubscribed: isRewardsSubscribed,
            isMessagingSubscribed: isMessagingSubscribed,
            isAnalyticsSubscribed: isAnalyticsSubscribed,
            showGrowthMenu: showGrowthMenu,
            isTableReservationEnabled: isTableReservationEnabled,
            ischatBotEnabled: ischatBotEnabled,
            isMediaGalleryEnabled: isMediaGalleryEnabled,
            isDocumentManagerEnabled: isDocumentManagerEnabled,
            isQrDiningEnabled: isQrDiningEnabled,
            campaignUrl: campaignUrl,
            invoicesUrl: invoicesUrl,
            isCampaignSubscribed: isCampaignSubscribed,
            isStoreSubscribed: isStoreSubscribed,
            isInvoiceSubscribed: isInvoiceSubscribed,
            isSeoOptimizationEnabled: isSeoOptimizationEnabled,
            seoUrl: seoUrl,
            isResourceEnabled: !!data.data.isResourceEnabled,
          },
        });
        defaultImage = data.data.logo;
        logo = data.data.image
        localStorage.setItem("logo",logo)
      }
    } catch (error) {
      messageShow("Some error occurred. Please try again.", error);
    }
  };

  toggleSidebar = () => {
    this.setState(prevState => ({ isSidebarOpen: !prevState.isSidebarOpen }));
  };

  handleResize = () => {
    if (window.innerWidth > 768) { 
      this.setState({ isSidebarOpen: true });
    } else {
      this.setState({ isSidebarOpen: false });
    }
  };

  handleAccordionChange = (accordionId) => {
    this.setState((prevState) => ({ isAExpanded: prevState.isAExpanded === accordionId ? null : accordionId,}));
  };

  openCampaignSite = () => {
    const { settings } = this.state;

    if (!settings.campaignUrl) {
      alert("Campaign URL not configured");
      return;
    }

    try {
      const user = localStorage.getItem("user");
      const token = document.cookie.split("; ").find(row => row.startsWith("token="))?.split("=")[1];
      const campaignWindow = window.open(settings.campaignUrl, "_blank");

      let attempts = 0;
      const interval = setInterval(() => {
        if (campaignWindow && !campaignWindow.closed) {
          campaignWindow.postMessage(
            { type: "CAMPAIGN_AUTH", user, token },
            "*"
          );
        }
        attempts++;
        if (attempts >= 15) {
          clearInterval(interval);
        }
      }, 1000);
    } catch (error) {
      console.error("Error opening Campaign URL:", error);
    }
  };

  openInvoicesSite = () => {
    const { settings } = this.state;

    if (!settings.invoicesUrl) {
      alert("Invoices URL not configured");
      return;
    }

    try {
      const user = localStorage.getItem("user");
      const token = document.cookie.split("; ").find(row => row.startsWith("token="))?.split("=")[1];
      const invoicesWindow = window.open(settings.invoicesUrl, "_blank");

      setTimeout(() => {
        if (invoicesWindow) {
          invoicesWindow.postMessage(
            { type: "INVOICES_AUTH", user, token },
            settings.invoicesUrl
          );
        }
      }, 1000);
    } catch (error) {
      console.error("Error opening Invoices URL:", error);
    }
  };

  openSeoSite = () => {
    const { settings } = this.state;

    if (!settings.seoUrl) {
      alert("SEO URL not configured");
      return;
    }

    try {
      const user = localStorage.getItem("user");
      let currentRoleName = "";
      try {
        const parsedUser = JSON.parse(user);
        currentRoleName = parsedUser.roleDetails?.name || parsedUser.roleName || "";
      } catch (e) {
        console.error("Error parsing user for SEO role:", e);
      }

      const token = document.cookie.split("; ").find(row => row.startsWith("token="))?.split("=")[1];
      const seoWindow = window.open(settings.seoUrl, "_blank");

      setTimeout(() => {
        if (seoWindow) {
          seoWindow.postMessage(
            { type: "SEO_AUTH", user, token, roleName: currentRoleName },
            settings.seoUrl
          );
        }
      }, 1000);
    } catch (error) {
      console.error("Error opening SEO URL:", error);
    }
  };

  render() {
    const toolTipStyle = [{
        name: 'offset',
        options: {
          offset: [0, -20],
        },
    }]
    const {
      classes,
      auth: { user },
    } = this.props;
    const { settings, isHovered, isSidebarOpen, isAExpanded, permissions, roleName } = this.state;
    // console.log("Permissions: ",permissions)
    
    const sidebarStyle = {
      width: isSidebarOpen ? '200px' : '60px',
      transition: 'width 0.3s ease',
    };
    const iconStyle = {
      color: isHovered ? "rgb(237,108,2)" : "grey",
      cursor: "pointer",
      transition: "color 0.3s",
    };
    const isSuperAdmin = roleName === "Super Admin";

    const canView = (module) => {
      if (isSuperAdmin) return true;
      return (
        permissions[module]?.isEnabled &&
        permissions[module]?.permissions?.canView !== false
      );
    };

    const canViewSub = (module, subModulePath) => {
      if (isSuperAdmin) return true;
      const modPerm = permissions?.[module];
      if (!modPerm?.isEnabled || modPerm?.permissions?.canView === false) {
        return false;
      }
      if (!subModulePath) return true;

      const parts = subModulePath.split('.');
      let current = modPerm;
      for (const part of parts) {
        if (!current?.subModules || !current.subModules[part]) {
          return false;
        }
        current = current.subModules[part];
      }

      if (current?.isEnabled === false) return false;
      if (current?.permissions && current.permissions.canView === false) return false;

      return true;
    };

    const hasLive = canViewSub('store', 'orders.liveOrders');
    const hasHistory = canViewSub('store', 'orders.orderHistory') || canViewSub('store', 'orders');
    const preferredOrdersRoute = isSuperAdmin || hasLive ? routes.orderLive.path(1) : routes.orderList.path(1);

    const hasReports = canViewSub('store', 'reports');
    const hasAnalytics = canViewSub('store', 'analytics');

    const hasStoreItems = isSuperAdmin || (
      (canView('store') && (hasLive || hasHistory)) ||
      canViewSub('store', 'products') ||
      canViewSub('store', 'category') ||
      canViewSub('store', 'customers') ||
      canViewSub('store', 'tableReservation') ||
      canViewSub('store', 'qrDining') ||
      canViewSub('store', 'banners') ||
      hasReports ||
      hasAnalytics
    );

    const hasMarketingItems = isSuperAdmin || (
      (canViewSub('marketing', 'resource') && settings.isResourceEnabled) ||
      canViewSub('marketing', 'campaign') ||
      canViewSub('marketing', 'mediaGallery') ||
      canViewSub('marketing', 'faq') ||
      canViewSub('marketing', 'messaging') ||
      canViewSub('marketing', 'reward') ||
      (canViewSub('marketing', 'newsletter') && settings.isResourceEnabled)
    );

    const hasEngagementItems = isSuperAdmin || (
      canViewSub('engagement', 'crm') ||
      canViewSub('engagement', 'users') ||
      canViewSub('engagement', 'calendar') ||
      canViewSub('engagement', 'feedback') ||
      canViewSub('engagement', 'intentManager')
    );

    const hasUtilitiesItems = isSuperAdmin || (
      canViewSub('utilities', 'storeSettings') ||
      canViewSub('utilities', 'qrGenerator') ||
      canViewSub('utilities', 'areas') ||
      canViewSub('utilities', 'teams') ||
      canViewSub('utilities', 'seo') ||
      canViewSub('utilities', 'documentManager') ||
      (canViewSub('utilities', 'invoices') && settings.isInvoiceSubscribed)
    );

    return (
      <div className={classes.sidenavWrapper} style={sidebarStyle}>
        <div
          className={`${classes.sidenav} ${
            isSidebarOpen ? classes.expanded : ""
          }`}
        >
          {/* Menu Toggle */}
          <ListItem
            onMouseEnter={() => this.setState({ isHovered: true })}
            onMouseLeave={() => this.setState({ isHovered: false })}
          >
            <ListItemIcon onClick={this.toggleSidebar} style={iconStyle}>
              {isSidebarOpen ? (
                <ArrowBackIcon style={iconStyle} />
              ) : (
                <MenuIcon style={iconStyle} />
              )}
            </ListItemIcon>
            <ListItemText
              primary={isSidebarOpen ? "Menu" : ""}
              style={iconStyle}
            />
          </ListItem>
          {user.role === params.user.roles.admin.key && (
            <>
              {/* Daily Operations */}

            {(isSuperAdmin || canView('dashboard')) && (
              <ListItem to={routes.userDashboard.path} component={Link} button>
                <Tooltip title={isSidebarOpen ? "" : "Dashboard"} arrow placement="right"
  PopperProps={{
    modifiers: toolTipStyle
  }}>
                  <ListItemIcon>
                    <IconDashboardOutlined
                      color={this.isActiveRoute(routes.userDashboard.path)}
                    />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={isSidebarOpen ? "Dashboard" : ""} style={{ color: this.isActiveRoute(routes.userDashboard.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
              </ListItem>)}
              {settings.isStoreSubscribed && hasStoreItems && (
                <Accordion expanded={isAExpanded === "store" || isAExpanded === false} onChange={() => this.handleAccordionChange("store")}>
                  <Tooltip title={isSidebarOpen ? "" : "Store"} arrow placement="right"
                    PopperProps={{
                      modifiers: [{
                        name: 'offset',
                        options: { offset: [0, -20] },
                      }],
                    }}>
                    <AccordionSummary
                      expandIcon={<StoreIcon style={{ color: "#0d3559", transform: 'none' }} />}
                      sx={{
                        '& .MuiAccordionSummary-expandIconWrapper': {
                          transform: 'none !important'
                        }
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        color="textSecondary"
                        style={{ color: "#0d3559" }}
                      >
                        {isSidebarOpen && "Store"}
                      </Typography>
                    </AccordionSummary>
                  </Tooltip>

                  <AccordionDetails style={{ padding: "0px" }}>
                    {(isSuperAdmin || hasLive || hasHistory) && (
                      <ListItem to={preferredOrdersRoute} component={Link} button>
                        <Tooltip title={isSidebarOpen ? "" : "Orders"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                          <ListItemIcon>
                            <IconShoppingCartOutlined color={this.isActiveRoute(routes.orderLive.path(1), routes.orderList.activePath) === "warning" ? "rgb(237,108,2)" : "inherit"}/>
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary={isSidebarOpen ? "Orders" : ""} style={{ color: this.isActiveRoute(routes.orderLive.path(1), routes.orderList.activePath) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                      </ListItem>
                    )}

                    {canViewSub('store', 'products') && (
                      <ListItem to={routes.productList.path(1)} component={Link} button>
                        <Tooltip title={isSidebarOpen ? "" : "Products"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                          <ListItemIcon>
                            <IconFilterNoneOutlined color={this.isActiveRoute(routes.productList.activePath)} />
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary={isSidebarOpen ? "Products" : ""} style={{ color: this.isActiveRoute(routes.productList.activePath) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                      </ListItem>
                    )}

                    {canViewSub('store', 'category') && (
                      <ListItem to={routes.categoryList.path} component={Link} button>
                        <Tooltip title={isSidebarOpen ? "" : "Categories"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                          <ListItemIcon>
                            <IconCategoryOutlined color={this.isActiveRoute(routes.categoryList.path)} />
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary={isSidebarOpen ? "Categories" : ""} style={{ color: this.isActiveRoute(routes.categoryList.path) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                      </ListItem>
                    )}

                    {canViewSub('store', 'customers') && (
                      <ListItem to={routes.customerList.path(1)} component={Link} button>
                        <Tooltip title={isSidebarOpen ? "" : "Customers"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                          <ListItemIcon>
                            <IconPeopleOutline color={this.isActiveRoute(routes.customerList.activePath)} />
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary={isSidebarOpen ? "Customers" : ""} style={{ color: this.isActiveRoute(routes.customerList.activePath) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                      </ListItem>
                    )}

                    {canViewSub('store', 'tableReservation') && (
                      <Tooltip title={settings.isTableReservationEnabled ? "" : "Subscribe to access this feature"}>
                        <ListItem
                          to={settings.isTableReservationEnabled ? routes.bookingsList.path : null}
                          component={settings.isTableReservationEnabled ? Link : "div"}
                          button={settings.isTableReservationEnabled}
                          disabled={!settings.isTableReservationEnabled}
                        >
                          <Tooltip title={isSidebarOpen ? "" : "Table Reservation"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                            <ListItemIcon>
                              <BookOnlineOutlinedIcon color={this.isActiveRoute(routes.bookingsList.path)} />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary={isSidebarOpen ? "Table Reservation" : ""} style={{ color: this.isActiveRoute(routes.bookingsList.path) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                        </ListItem>
                      </Tooltip>
                    )}

                    {canViewSub('store', 'qrDining') && (
                      <Tooltip title={settings.isQrDiningEnabled ? "" : "Subscribe to access this feature"}>
                        <ListItem
                          to={settings.isQrDiningEnabled ? routes.qrTableList.path : null}
                          component={settings.isQrDiningEnabled ? Link : "div"}
                          button={settings.isQrDiningEnabled}
                          disabled={!settings.isQrDiningEnabled}
                        >
                          <Tooltip title={isSidebarOpen ? "" : "QR Dining"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                            <ListItemIcon>
                              <TableRestaurantIcon color={this.isActiveRoute(routes.qrTableList.path)} />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary={isSidebarOpen ? "QR Dining" : ""} style={{ color: this.isActiveRoute(routes.qrTableList.path) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                        </ListItem>
                      </Tooltip>
                    )}
                    {canViewSub('store', 'banners') && (
                      <ListItem to={routes.bannerList.path} component={Link} button>
                        <Tooltip title={isSidebarOpen ? "" : "Banners"} arrow placement="right"
                          PopperProps={{
                            modifiers: toolTipStyle
                          }}
                        >
                          <ListItemIcon>
                            <IconPhotoLibraryOutlined
                              color={this.isActiveRoute(routes.bannerList.path)}
                            />
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary={isSidebarOpen ? "Banners" : ""} style={{ color: this.isActiveRoute(routes.bannerList.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
                      </ListItem>)}

              {hasReports && (
              <ListItem to={settings.isStoreSubscribed ? routes.userReports.path : null} component={Link} button>
                <Tooltip title={isSidebarOpen ? "" : "Reports"} arrow placement="right"
  PopperProps={{
    modifiers: toolTipStyle
  }}>
                  <ListItemIcon>
                    <IconBarChart
                      color={this.isActiveRoute(routes.userReports.path)}
                    />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={isSidebarOpen ? "Reports" : ""} style={{ color: this.isActiveRoute(routes.userReports.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
              </ListItem>)}
              {hasAnalytics && (
              <Tooltip
                title={
                  settings.isAnalyticsSubscribed
                    ? ""
                    : "Subscribe to access this feature"
                }
              >
                <ListItem
                  to={settings.isAnalyticsSubscribed && settings.isStoreSubscribed ? routes.analytics.path : null}
                  component={settings.isAnalyticsSubscribed ? Link : "div"}
                  button={settings.isAnalyticsSubscribed}
                  disabled={!settings.isAnalyticsSubscribed}
                >
                  <Tooltip title={isSidebarOpen ? "" : "Analytics"} arrow placement="right"
  PopperProps={{
    modifiers: toolTipStyle
  }}>
                    <ListItemIcon>
                      <TrendingUpRoundedIcon
                        color={this.isActiveRoute(routes.analytics.path)}
                      />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "Analytics" : ""} style={{ color: this.isActiveRoute(routes.analytics.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
                </ListItem>
              </Tooltip>)}
                  </AccordionDetails>
                </Accordion>
              )}

              {/* Marketing & Communication */}
        {hasMarketingItems && (
        <Accordion expanded={isAExpanded === "marketing"} onChange={()=>this.handleAccordionChange("marketing")}>
          <Tooltip title={isSidebarOpen ? "" : "Marketing"} arrow placement="right"
              PopperProps={{
                modifiers: [{
                  name: 'offset',
                  options: {
                    offset: [0, -20],
                  },
                }],
              }}>

          <AccordionSummary expandIcon={<Marketing style={{color:"#0d3559", transform: 'none'}} />}
            sx={{
              '& .MuiAccordionSummary-expandIconWrapper': {
                transform: 'none !important'
              }
            }}
          >
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  style={{
                    color: "#0d3559"
                  }}
                  >
                  {isSidebarOpen && "Marketing"}
                </Typography>
            </AccordionSummary>
          </Tooltip>
          <AccordionDetails style={{padding:"0px"}}>
              {canViewSub('marketing', 'resource') && settings.isResourceEnabled && (
                <ListItem to={routes.cmsList.path} component={Link} button>
                  <Tooltip title={isSidebarOpen ? "" : "Resources"} arrow placement="right"
                    PopperProps={{
                      modifiers: toolTipStyle
                    }}>
                    <ListItemIcon>
                      <PsychologyIcon
                        color={this.isActiveRoute(routes.cmsList.path)}
                      />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "Resources" : ""} style={{ color: this.isActiveRoute(routes.cmsList.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
                </ListItem>
              )}

            {canViewSub('marketing', 'campaign') && (
              <Tooltip title={settings.isCampaignSubscribed ? "" : "Subscribe to access this feature"}>
                <ListItem
                  button={settings.isCampaignSubscribed}
                  onClick={settings.isCampaignSubscribed ? this.openCampaignSite : null}
                  disabled={!settings.isCampaignSubscribed}
                >
                  <Tooltip title={isSidebarOpen ? "" : "Campaign"} arrow placement="right"
                    PopperProps={{ modifiers: toolTipStyle }}>
                    <ListItemIcon>
                      <Marketing color="inherit" />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "Campaign" : ""} />
                </ListItem>
              </Tooltip>
            )}


              {canViewSub('marketing', 'mediaGallery') && (
  <Tooltip
    title={
      settings.isMediaGalleryEnabled
        ? ""
        : "Media Gallery access is not enabled for this store"
    }
  >
    <ListItem
      to={settings.isMediaGalleryEnabled ? routes.mediaGalleryList.path : null}
      component={settings.isMediaGalleryEnabled ? Link : "div"}
      button={settings.isMediaGalleryEnabled}
      disabled={!settings.isMediaGalleryEnabled}
    >
      <Tooltip
        title={isSidebarOpen ? "" : "Media Gallery"}
        arrow
        placement="right"
        PopperProps={{
          modifiers: toolTipStyle,
        }}
      >
        <ListItemIcon>
          <IconMediaGallery
            color={this.isActiveRoute(routes.mediaGalleryList.path)}
          />
        </ListItemIcon>
      </Tooltip>
      <ListItemText
        primary={isSidebarOpen ? "Media Gallery" : ""}
        style={{
          color:
            this.isActiveRoute(routes.mediaGalleryList.path) === "warning"
              ? "rgb(237,108,2)"
              : "inherit",
        }}
      />
    </ListItem>
  </Tooltip>
)}

              {canViewSub('marketing', 'faq') && (
              <ListItem to={routes.faq.path} component={Link} button>
                <Tooltip title={isSidebarOpen ? "" : "FAQ"} arrow placement="right"
  PopperProps={{
    modifiers: toolTipStyle
  }}>
                  <ListItemIcon>
                    <QuizIcon color={this.isActiveRoute(routes.faq.path)} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={isSidebarOpen ? "FAQ" : ""} style={{ color: this.isActiveRoute(routes.faq.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
              </ListItem>)}
              {canViewSub('marketing', 'messaging') && (
              <Tooltip
                title={
                  settings.isMessagingSubscribed
                    ? ""
                    : "Subscribe to access this feature"
                }
              >
                <ListItem
                  to={settings.isMessagingSubscribed ? routes.messaging.path : null}
                  component={settings.isMessagingSubscribed ? Link : "div"}
                  button={settings.isMessagingSubscribed}
                  disabled={!settings.isMessagingSubscribed}
                >
                  <Tooltip title={isSidebarOpen ? "" : "Messaging"} arrow placement="right"
  PopperProps={{
    modifiers: toolTipStyle
  }}>
                    <ListItemIcon>
                      <SendIcon color={this.isActiveRoute(routes.messaging.path)} />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "Messaging" : ""} style={{ color: this.isActiveRoute(routes.messaging.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
                </ListItem>
              </Tooltip>)}
              {canViewSub('marketing', 'reward') && (
              <Tooltip
                title={
                  settings.isRewardsSubscribed
                    ? ""
                    : "Subscribe to access this feature"
                }
              >
                <ListItem
                  to={settings.isRewardsSubscribed ? routes.listAllTabs.path : null}
                  component={settings.isRewardsSubscribed ? Link : "div"}
                  button={settings.isRewardsSubscribed}
                  disabled={!settings.isRewardsSubscribed}
                >
                  <Tooltip title={isSidebarOpen ? "" : "Rewards"} arrow placement="right"
  PopperProps={{
    modifiers: toolTipStyle
  }}>
                    <ListItemIcon>
                      <GiftIcon
                        color={this.isActiveRoute(routes.listAllTabs.path, routes.listPoints.path, routes.listRewards.path, routes.listLeaderboard.path)}
                      />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "Rewards" : ""}
                    style={{
                      color:
                        this.isActiveRoute(routes.listAllTabs.path, routes.listPoints.path, routes.listRewards.path, routes.listLeaderboard.path) === "warning"
                          ? "rgb(237,108,2)"
                          : "inherit"
                    }}
                    />
                </ListItem>
              </Tooltip>)}

              {canViewSub('marketing', 'newsletter') && settings.isResourceEnabled && (
                <ListItem to={routes.subscribers.path(1)} component={Link} button>
                  <Tooltip title={isSidebarOpen ? "" : "Newsletter Subscribers"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                    <ListItemIcon>
                      <IconPeopleOutline color={this.isActiveRoute(routes.subscribers.activePath)} />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "Newsletter Subscribers" : ""} style={{ color: this.isActiveRoute(routes.subscribers.activePath) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                </ListItem>
              )}

              </AccordionDetails>
            </Accordion>
          )}



              {/* Customer Engagement */}
        {hasEngagementItems && (
        <Accordion expanded={isAExpanded === "engagement"} onChange={()=>this.handleAccordionChange("engagement")}>
          <Tooltip title={isSidebarOpen ? "" : "Engagement"} arrow placement="right"
              PopperProps={{
                modifiers: [{
                  name: 'offset',
                  options: {
                    offset: [0, -20],
                  },
                }],
              }}>
            <AccordionSummary expandIcon={<Engagement style={{color:"#0d3559", transform: 'none'}} />}
              sx={{
                '& .MuiAccordionSummary-expandIconWrapper': {
                  transform: 'none !important'
                }
              }}
            >
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  style={{
                    color: "#0d3559"
                  }}
                >
                  {isSidebarOpen && "Engagement"}
                </Typography>
            </AccordionSummary>
          </Tooltip>
          <AccordionDetails style={{padding:"0px"}}>
              {canViewSub('engagement', 'crm') && (
              <Tooltip
                title={
                  settings.showGrowthMenu ? "" : "Subscribe to access this feature"
                }
              >
                <ListItem
                  to={settings.showGrowthMenu ? routes.listContacts.path : null}
                  component={settings.showGrowthMenu ? Link : "div"}
                  button={settings.showGrowthMenu}
                  disabled={!settings.showGrowthMenu}
                >
                  <Tooltip title={isSidebarOpen ? "" : "CRM"} arrow placement="right"
  PopperProps={{
    modifiers: toolTipStyle
  }}>
                    <ListItemIcon>
                      <CoPresentIcon
                        color={this.isActiveRoute(routes.listContacts.path)}
                      />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "CRM" : ""} style={{ color: this.isActiveRoute(routes.listContacts.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
                </ListItem>
              </Tooltip>)}
              {canViewSub('engagement', 'users') && (
                <ListItem to={routes.engagementUsers.path(1)} component={Link} button>
                  <Tooltip title={isSidebarOpen ? "" : "Users"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                    <ListItemIcon>
                      <PeopleIcon color={this.isActiveRoute(routes.engagementUsers.path(1), routes.engagementUsers.activePath)} />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText
                    primary={isSidebarOpen ? "Users" : ""}
                    style={{
                      color: this.isActiveRoute(routes.engagementUsers.path(1), routes.engagementUsers.activePath) === "warning" ? "rgb(237,108,2)" : "inherit"
                    }}
                  />
                </ListItem>
              )}
            {canViewSub('engagement', 'calendar') && (
                <ListItem to={routes.googleCalendar.path} component={Link} button>
                  <Tooltip title={isSidebarOpen ? "" : "Calendar"} arrow placement="right" PopperProps={{ modifiers: toolTipStyle }}>
                    <ListItemIcon>
                      <EventIcon color={this.isActiveRoute(routes.googleCalendar.path)} />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "Calendar" : ""} style={{ color: this.isActiveRoute(routes.googleCalendar.path) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                </ListItem>
              )}
              {canViewSub('engagement', 'feedback') && (
              <ListItem to={routes.ratingFeedback.path(1)} component={Link} button>
                <Tooltip title={isSidebarOpen ? "" : "Feedback"} arrow placement="right"
  PopperProps={{
    modifiers: toolTipStyle
  }}>
                  <ListItemIcon>
                    <IconForumOutlined
                      color={this.isActiveRoute(routes.ratingFeedback.path(1))}
                    />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={isSidebarOpen ? "Feedback" : ""} style={{ color: this.isActiveRoute(routes.ratingFeedback.path(1)) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
              </ListItem>)}
              {canViewSub('engagement', 'intentManager') && (
                  <Tooltip
                    title={
                     settings.ischatBotEnabled
                       ? ""
                       : "Subscribe to access this feature"
                    }
                  >
                <ListItem
                  to={settings.ischatBotEnabled ? routes.intentsList.path : null}
                  component={settings.ischatBotEnabled ? Link : "div"}
                  button={settings.ischatBotEnabled}
                  disabled={!settings.ischatBotEnabled}
                >

                <Tooltip title={isSidebarOpen ? "" : "Intent Manager" } arrow placement="right"
                  PopperProps={{
                    modifiers: toolTipStyle
                }}>
                  <ListItemIcon>
                     <PsychologyIcon
                       color={this.isActiveRoute(routes.intentsList.path, routes.knowledgeCreate.path, routes.intentCreate.path, routes.intentEdit.path, routes.botSettings.path)}
                      />
                  </ListItemIcon>
                 </Tooltip>
                <ListItemText primary={isSidebarOpen ? "Intent Manager" : "" }
                 style={{
                  color:
                    this.isActiveRoute(routes.intentsList.path, routes.knowledgeCreate.path, routes.intentCreate.path, routes.intentEdit.path, routes.botSettings.path) === "warning"
                      ? "rgb(237,108,2)"
                      : "inherit"
                }}
                 />
              </ListItem>
              </Tooltip>)}

          </AccordionDetails>
        </Accordion>)}


              {/* Support & Utilities */}
        {hasUtilitiesItems && (
        <Accordion expanded={isAExpanded==="utilities"} onChange={()=>this.handleAccordionChange("utilities")}>
            <Tooltip title={isSidebarOpen ? "" : "Utilities"} arrow placement="right"
              PopperProps={{
                modifiers: [{
                  name: 'offset',
                  options: {
                    offset: [0, -20],
                  },
                }],
              }}>
            <AccordionSummary expandIcon={<Utilities style={{color:"#0d3559", transform: 'none'}} />}
              sx={{
                '& .MuiAccordionSummary-expandIconWrapper': {
                  transform: 'none !important'
                }
              }}
            >
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  style={{
                    color: "#0d3559"
                  }}
                  >
                  {isSidebarOpen && "Utilities"}
                </Typography>
            </AccordionSummary>
          </Tooltip>
          <AccordionDetails style={{ padding: "0px" }}>
            {canViewSub('utilities', 'storeSettings') && (
              <ListItem to={routes.vendorList.path(1)} component={Link} button>
                <Tooltip title={isSidebarOpen ? "" : "Account"} arrow placement="right"
                  PopperProps={{
                    modifiers: toolTipStyle
                  }}>
                  <ListItemIcon>
                    <AccountCircleIcon
                      color={this.isActiveRoute(routes.vendorList.activePath)}
                    />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={isSidebarOpen ? "Account" : ""} style={{ color: this.isActiveRoute(routes.vendorList.activePath) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
              </ListItem>)}
            {canViewSub('utilities', 'qrGenerator') && (
              <ListItem to={routes.qrCode.path} component={Link} button>
                <Tooltip title={isSidebarOpen ? "" : "QR Generator"} arrow placement="right"
                  PopperProps={{
                    modifiers: toolTipStyle
                  }}>
                  <ListItemIcon>
                    <QrCode color={this.isActiveRoute(routes.qrCode.path)} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={isSidebarOpen ? "QR Generator" : ""} style={{ color: this.isActiveRoute(routes.qrCode.path) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
              </ListItem>)}
              {canViewSub('utilities', 'invoices') && settings.isInvoiceSubscribed && (
                <ListItem button onClick={this.openInvoicesSite}>
                  <Tooltip
                    title={isSidebarOpen ? "" : "Invoices"}
                    arrow
                    placement="right"
                    PopperProps={{ modifiers: toolTipStyle }}
                  >
                    <ListItemIcon>
                      <BusinessCenter color="inherit" />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={isSidebarOpen ? "Invoices" : ""} />
                </ListItem>
              )}
            {canViewSub('utilities', 'areas') && (
              <ListItem to={routes.pincodeList.path} component={Link} button>
                <Tooltip title={isSidebarOpen ? "" : "Areas"} arrow placement="right"
                  PopperProps={{
                    modifiers: toolTipStyle
                  }}>
                  <ListItemIcon>
                    <IconLocationCityOutlined
                      color={this.isActiveRoute(routes.pincodeList.path)}
                    />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={isSidebarOpen ? "Areas" : ""} style={{ color: this.isActiveRoute(routes.pincodeList.path) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
              </ListItem>)}
                    {canViewSub('utilities', 'teams') && (
                      <ListItem to={routes.teams.path} component={Link} button>
                        <Tooltip title={isSidebarOpen ? "" : "Teams"} arrow placement="right"
                          PopperProps={{
                            modifiers: toolTipStyle
                          }}>
                          <ListItemIcon>
                            <SecurityIcon color={this.isActiveRoute(routes.teams.path)} />
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary={isSidebarOpen ? "Teams" : ""} style={{ color: this.isActiveRoute(routes.teams.path) === "warning" ? "rgb(237,108,2)" : "inherit" }} />
                      </ListItem>)}
                    {canViewSub('utilities', 'seo') && (
                      <Tooltip title={settings.isSeoOptimizationEnabled ? "" : "Subscribe to access this feature"}>
                        <ListItem
                          button={settings.isSeoOptimizationEnabled}
                          onClick={settings.isSeoOptimizationEnabled ? this.openSeoSite : null}
                          disabled={!settings.isSeoOptimizationEnabled}
                        >
                          <Tooltip title={isSidebarOpen ? "" : "SEO"} arrow placement="right"
                            PopperProps={{ modifiers: toolTipStyle }}>
                            <ListItemIcon>
                              <Marketing color="inherit" />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary={isSidebarOpen ? "SEO" : ""} />
                        </ListItem>
                      </Tooltip>
                    )}
              {canViewSub('utilities', 'documentManager') && (
                <Tooltip title={settings.isDocumentManagerEnabled ? "" : "Subscribe to access this feature"}>
                  <ListItem
                    to={settings.isDocumentManagerEnabled ? routes.documents.path : null}
                    component={settings.isDocumentManagerEnabled ? Link : "div"}
                    button={settings.isDocumentManagerEnabled}
                    disabled={!settings.isDocumentManagerEnabled}
                  >
                    <Tooltip title={isSidebarOpen ? "" : "Document Manager"} arrow placement="right"
                      PopperProps={{
                        modifiers: toolTipStyle
                      }}>
                      <ListItemIcon>
                        <DescriptionIcon
                          color={this.isActiveRoute(routes.documents.path)}
                        />
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={isSidebarOpen ? "Document Manager" : ""} style={{ color: this.isActiveRoute(routes.documents.path) === "warning" ? "rgb(237,108,2)" : "inherit" }}/>
                  </ListItem>
                </Tooltip>
              )}
          </AccordionDetails>
        </Accordion>)}

              {/* Footer */}
              {/* <ListItem style={{ backgroundColor: '#0d3559', color: 'white' }}>
                <Typography variant="caption" color="inherit">
                  &copy; {params.site.year}{" "}
                  <a
                    href={params.site.url.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'white', textDecoration: 'underline' }}
                  >
                    {params.site.name}
                  </a>
                </Typography>
              </ListItem> */}
            </>
          )}
            {/* <ListItem
                to={routes.settings.path}
                component={Link}
                button
              >
                <ListItemIcon>
                  <IconSettingsOutlined color={this.isActiveRoute(routes.settings.path)} />
                </ListItemIcon>
                <ListItemText primary="Settings" />
              </ListItem> */}
            {/*<ListItem
                to={routes.broadcastList.path}
                component={Link}
                button
              >
                <ListItemIcon>
                  <IconForumOutlined color={this.isActiveRoute(routes.broadcastList.path)} />
                </ListItemIcon>
                <ListItemText primary="Broadcast Msg" />
              </ListItem>*/}
            {/* <ListItem
                  to={routes.deliveryBoyList.path}
                  component={Link}
                  button
                >
                  <ListItemIcon>
                    <IconDirectionsBikeOutlined color={this.isActiveRoute(routes.deliveryBoyList.path)} />
                  </ListItemIcon>
                  <ListItemText primary="Delivery Boy" />
              </ListItem> */}
        </div>
      </div>
    );
  }
}

// Component Properties
Sidebar.propTypes = {
  auth: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  messageShow: PropTypes.func.isRequired,
  detail: PropTypes.func.isRequired,
};

// Component State
function sidebarState(state) {
  return {
    auth: state.auth,
  };
}

export default withRouter(
  connect(sidebarState, { detail, messageShow })(withStyles(styles)(Sidebar))
);

export { defaultImage, logo };